import './Loader.css';
import { FaCircleNotch } from 'react-icons/fa';
import React from 'react';

const Loader: React.FC = () => {
  return (
    <div className='containerLoader'>
      <div className='box'>
        <FaCircleNotch />
      </div>
    </div>
  );
};

export default Loader;
